<template>
    <div class="page_not_found">잘못된 접근입니다.</div>
</template>

<script>
    export default {
        name: "pagenotfound"
    }
</script>

<style scoped>
    .page_not_found{
        display:flex;
        justify-content: center;
        align-items: center;
        font-size:20px;
        font-weight:bold;
    }
</style>